import { Button } from "@narmi/design_system";
import { useLocalization } from "@fluent/react";
import type Account from "byzantine/src/Account";
import { useUserFeatures } from "../contexts/UserFeaturesContext";
import SectionCard from "../SectionCard";

const PaymentActivityCard = ({ account }: { account: Account }) => {
  const { l10n } = useLocalization();
  const features = useUserFeatures();
  const hasWireFeature =
    features.wires ||
    features.international_wires ||
    features.international_wires_consumer;

  if (!features.payment_activity || !hasWireFeature) {
    return null;
  }

  return (
    <SectionCard>
      <SectionCard.Title
        text={l10n.getString("payment-activity-title")}
        button={
          <Button
            kind="plain"
            onClick={() =>
              window.location.assign(
                `/payment_activity?institution_account_in=${account.id}`
              )
            }
            label={l10n.getString("view-activity-label", null, "View activity")}
            testId="payment-activity-card"
          />
        }
      />
    </SectionCard>
  );
};

export default PaymentActivityCard;
